import type { Product } from '@commerce/types'
export type SelectedOptions = Record<string, string | null>
import { SelectOption } from '@components/product/SizeSelector'

export function getProductSize(product: Product.Product) {
  return product.variants
    .flatMap((variant) => variant.options)
    .filter((variant) => {
      return (
        variant.displayName === 'size' ||
        variant.displayName === 'denominations'
      )
    })
    .map((variant) => ({
      label: variant.values[0].label,
      value: variant.id,
    }))
}

export function getProductSizesAndVariantDetails(
  product: Product.Product,
  details: Array<keyof Product.ProductVariant>
) {
  return product.variants.reduce((acc, variant) => {
    const variantAttributes: Partial<SelectOption> = {}

    variant?.options
      .filter(
        (option) =>
          option.displayName === 'size' ||
          option.displayName === 'denominations'
      )
      .map((option) => {
        variantAttributes.label = option.values[0].label
        variantAttributes.value = option.id
      })
    if (!variantAttributes.label) return acc
    details.forEach((key) => (variantAttributes[key] = variant[key] as any))
    acc.push(variantAttributes)
    return acc
  }, [] as Partial<SelectOption>[])
}
